import axios from 'axios';
import Vue from 'vue';

const fetchClient = () => {
  const defaultOptions = {
    // baseURL: 'http://aend.iptime.org:7020/v1',
    //baseURL: 'http://localhost:3000/v1',
    baseURL: 'http://aendsoft.com:7020/v1',
    headers: {
      Authorization: '',
      "Content-Type": "application/json;charset=utf-8"
		// "Access-Control-Allow-Origin": "*",
		// "Access-Control-Allow-Headers": "*",
		// "Access-Control-Allow-Credentials": false,
    },
  };

  let instance = axios.create(defaultOptions);

  // 요청 인터셉터
  // 매 요청마다 "token" 이름으로 저장된 쿠키의 값이 존재하면 헤더에 설정 후 서버에 보냅니다. 
  instance.interceptors.request.use(
    function (config) {
      if (Vue.$cookies.get('token')) {
        config.headers.Authorization = 'bearer ' + Vue.$cookies.get('token');
      }
      return config;
    },
    function (error) {
      alert(error);
      return Promise.reject(error);
    }
  );

  return instance;
};

export default fetchClient();